import { useEffect, useRef, useState } from "react";

import { useFocusWithin } from "../../../hooks";
import { onSearchTab } from "../../../utilities";

export const useMainNavDropdown = ({
  event_label,
  event_value,
  searchTab
} = {}) => {
  const dropdownRef = useRef(null);
  const [isFocusWithin, setIsFocusWithin] = useFocusWithin(dropdownRef, {
    mouse: false
  });
  const prevFocusWithin = useRef(isFocusWithin);
  const [isActive, setActive] = useState(false);
  const onActiveToggle = () => {
    setActive(active => {
      const newActive = !active;
      if (newActive) {
        setIsFocusWithin(true);
      }
      return newActive;
    });
  };
  const onClose = () => {
    setActive(false);
  };

  useEffect(() => {
    if (prevFocusWithin.current && !isFocusWithin) {
      onClose();
    }
    prevFocusWithin.current = isFocusWithin;
  }, [isFocusWithin]);

  return {
    dropdownRef,
    isActive,
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      onActiveToggle();
      if (searchTab) {
        onSearchTab(searchTab);
      }

      return false;
    },
    onMouseEnter: () => {
      if (window?.dataLayer?.push && (event_label || event_value)) {
        window.dataLayer.push({
          event: "menu-hover",
          event_category: "site_header",
          event_action: "hover",
          event_label,
          event_value
        });
      }
      setActive(true);
    },
    onMouseLeave: onClose
  };
};
